import { LHeader } from "../styled/Header.style"
import { AppLogoLinear } from "../styled/Logo.style"
import AppLogoLinearImg from './../../assets/img/linearLogo.svg'

interface HeaderLinearProps {
  isInvLinear?: boolean;
}

const HeaderLinearCmp = (props: HeaderLinearProps) => {
    return (
        <>
            <LHeader $inverted={props.isInvLinear}>
                <AppLogoLinear src={AppLogoLinearImg} alt="Linear logo" />
            </LHeader>
        </>

    )
}

export default HeaderLinearCmp